module.exports = __webpack_public_path__ + "static/media/NvphFanpad.6ef0f19a.webp";